import React from 'react';
export function SocialProof() {
  return <section className="bg-brand-grayLight py-6 border-y border-slate-100" data-id="element-288">
      <div className="max-w-4xl mx-auto px-5" data-id="element-289">
        <p className="text-center text-[10px] font-bold text-slate-400 uppercase tracking-[0.2em] mb-6" data-id="element-290">
          CONFIADO POR PROFESIONALES DE BELLEZA Y PELUQUERÍA
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-291">
          <StatItem value="6" label="TOMOS COMPLETOS" data-id="element-292" />
          <StatItem value="+12" label="HERRAMIENTAS PRÁCTICAS" data-id="element-293" />
          <StatItem value="4.9/5" label="CALIFICACIÓN ⭐" data-id="element-294" />
          <StatItem value="🌎" label="Argentina y Latinoamérica" isEmoji data-id="element-295" />
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4 mt-6 pt-6 border-t border-slate-200" data-id="element-296">
          <span className="text-sm text-slate-500 font-semibold" data-id="element-297">
            📄 100% digital (PDF)
          </span>
          <span className="text-sm text-slate-500 font-semibold" data-id="element-298">
            ⚡ Acceso inmediato
          </span>
          <span className="text-sm text-slate-600 font-bold text-center w-full mt-2" data-id="element-299">
            🧠 Diseñado para profesionales que ya saben trabajar… pero quieren
            dejar de improvisar su operación diaria.
          </span>
        </div>
      </div>
    </section>;
}
function StatItem({
  value,
  label,
  isEmoji
}: {
  value: string;
  label: string;
  isEmoji?: boolean;
}) {
  return <div className="flex flex-col items-center justify-center" data-id="element-300">
      <div className={`${isEmoji ? 'text-4xl' : 'text-3xl md:text-4xl'} font-black text-brand-primary mb-2`} data-id="element-301">
        {value}
      </div>
      <div className="text-[10px] md:text-xs text-slate-500 font-bold uppercase tracking-wider leading-tight max-w-[120px]" data-id="element-302">
        {label}
      </div>
    </div>;
}